"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResiliencyConfiguration = void 0;
class ResiliencyConfiguration {
    constructor(retryCount = 5, backoffInterval = 10, circuitBreakerInterval = 60 * 1000, timeoutValue = 15000) {
        this.toString = () => {
            return `ResiliencyConfiguration (TimeOutValue: ${this._timeoutValue}) RetryCount: ${this._retryCount}) (BackoffInterval: ${this._backoffInterval})  (CircuitBreakerInterval: ${this._circuitBreakerInterval}) `;
        };
        this._retryCount = retryCount;
        this._backoffInterval = backoffInterval;
        this._circuitBreakerInterval = circuitBreakerInterval;
        this._timeoutValue = timeoutValue;
    }
    get retryCount() {
        return this._retryCount;
    }
    set retryCount(retryCount) {
        this._retryCount = retryCount;
    }
    get backoffInterval() {
        return this._backoffInterval;
    }
    get timeOutValue() {
        return this._timeoutValue;
    }
    set timeOutValue(timeOutValue) {
        this._timeoutValue = timeOutValue;
    }
    set backoffInterval(backoffInterval) {
        this._backoffInterval = backoffInterval;
    }
    set circuitBreakerInterval(circuitBreakerInterval) {
        this._circuitBreakerInterval = circuitBreakerInterval;
    }
    get circuitBreakerInterval() {
        return this._circuitBreakerInterval;
    }
}
exports.ResiliencyConfiguration = ResiliencyConfiguration;
